// Unpublished Work © 2025 Deere & Company.

import {IconCircleAdd, IconCircleMinus, IconSwap} from '@deere/icons';
import ActionsColumn from 'Ui/components/common/data-table/actions-column';
import React from 'react';

const ICON_STYLE = {
    style: {
        height: '14px',
        width: '14px',
        marginLeft: '5px'
    }
};

function getActionColumn(
    row,
    openTransferInventoryDialog,
    openPullInventoryDialog,
    openStockInventoryDialog,
    membershipHierarchy,
    partsData,
    dialogOnClose
) {
    const stockGreaterThanZero = row.quantity > 0;

    const actions = [];

    if (membershipHierarchy.children?.length > 0 && stockGreaterThanZero) {
        actions.push({
            buttonClassName: 'inline-icon-btn part-actions',
            iconComponent: IconSwap,
            iconProps: {
                ...ICON_STYLE,
                primary: '#357edd'
            },
            onClick: () => openTransferInventoryDialog({
                availableParts: partsData.formattedPartsFromInventoryBins,
                initialSelectedPart: row,
                inventories: partsData.inventories,
                membershipHierarchy,
                onClose: dialogOnClose
            })
        });
    }

    if (stockGreaterThanZero) {
        actions.push({
            buttonClassName: 'inline-icon-btn part-actions',
            iconComponent: IconCircleMinus,
            iconProps: {
                ...ICON_STYLE,
                primary: '#ff4136'
            },
            onClick: () => openPullInventoryDialog({
                availableParts: partsData.formattedPartsFromInventoryBins,
                initialSelectedPart: row,
                inventories: partsData.inventories,
                onClose: dialogOnClose
            })
        });
    }

    actions.push({
        buttonClassName: 'inline-icon-btn part-actions',
        iconComponent: IconCircleAdd,
        iconProps: {
            ...ICON_STYLE,
            primary: '#19a974'
        },
        onClick: () => openStockInventoryDialog({
            availableParts: partsData.parts,
            initialSelectedPart: row,
            inventories: partsData.inventories,
            onClose: dialogOnClose
        })
    });

    return (
        <ActionsColumn actions={actions}/>
    );
}

export {
    getActionColumn
};
